unit UMenuForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UStampModel,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UMainConfig, Types,
  Vcl.Grids, WEBLib.Grids, WEBLib.Buttons, WEBLib.ComCtrls;

type
  TMenuForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnMenu: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlMenu: TPanel;
    WebLabel1: TLabel;
    btnMyData: TBitBtn;
    btnClockIn: TBitBtn;
    btnTimeData: TBitBtn;
    btnAbwPlanner: TBitBtn;
    btnHoliday: TBitBtn;
    btnLogout: TBitBtn;
    pnlOverview: TPanel;
    pnlTop: TPanel;
    pnlBottom: TPanel;
    ws1: TSplitter;
    pnlTopPart1: TPanel;
    ws2: TSplitter;
    pnlTopPart2: TPanel;
    ws3: TSplitter;
    pnlTopPart3: TPanel;
    pnlTopPart1Header: TPanel;
    pnlTopPart1Main: TPanel;
    sgLastStamps: TStringGrid;
    pnlTopPart2Header: TPanel;
    pnlTopPart2Main: TPanel;
    sgForwardAccounts: TStringGrid;
    pnlTopPart3Header: TPanel;
    pnlTopPart3Main: TPanel;
    edtInfo: TRichEdit;
    pnlBottomHeader: TPanel;
    pnlBottomMain: TPanel;
    sgMonthOverview: TStringGrid;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnLogoutClick(Sender: TObject);
    procedure btnMenuClick(Sender: TObject);
    [Async]
    procedure btnMyDataClick(Sender: TObject); async;
    [Async]
    procedure btnClockInClick(Sender: TObject); async;
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    [Async]
    procedure btnTimeDataClick(Sender: TObject); async;
    [Async]
    procedure btnAbwPlannerClick(Sender: TObject); async;
    [Async]
    procedure btnHolidayClick(Sender: TObject); async;
    procedure WebFormCreate(Sender: TObject);
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    FForwardAccounts: TStringList;
    FStamp: TStampModel;
    FFakStamp: TStampModel;
    procedure GetCurrentBalance(index: Integer);
    procedure GetZeitart(index: Integer);
    procedure ClockInCallback(Sender: TObject);
    procedure GetForwardAccounts;
    procedure GetLastFakStamp;
    procedure GetLastStamps;
    procedure GetLastStampsCallback(Sender: TObject);
    procedure GetNotice;
    procedure GetOverview;
    procedure GetStatus;
    procedure SetButtons;
    procedure SetOverviewConfig;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetForwardAccounts(const Value: TStringList);
    procedure SetStamp(const Value: TStampModel);
    procedure SetFakStamp(const Value: TStampModel);
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property ForwardAccounts: TStringList read FForwardAccounts
      write SetForwardAccounts;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;

  protected procedure LoadDFMValues; override; end;

var
  MenuForm: TMenuForm;

implementation

uses
  System.Rtti, UMenuConfig, UUserModel, UStampList, Math, UGridHelper,
  UZeitartModel, UEssentialHelper, UValueModel, System.DateUtils,
  UPersonalDataForm,
  UClockInForm, UTimeDataForm, UAbwForm, UHolidayForm;

{$R *.dfm}
{ TMenuForm }

procedure TMenuForm.btnAbwPlannerClick(Sender: TObject);
var
  frm: TAbwForm;
begin
  Self.MainConfig.TimerReset;
  frm := TAbwForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TAbwForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
  end;
end;

procedure TMenuForm.btnClockInClick(Sender: TObject);
var
  frm: TClockInForm;
begin
  Self.MainConfig.TimerReset;
  frm := TClockInForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TClockInForm, frm.Load);
  frm.lblDate.Caption := FormatDateTime('dddd dd.mm.yyyy', now);
  frm.lblTime.Caption := FormatDateTime('hh:nn:ss', now);
  frm.MainConfig := Self.MainConfig;
  frm.OnPropertyChanged := ClockInCallback;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
  end;
end;

procedure TMenuForm.btnHolidayClick(Sender: TObject);
var
  frm: THolidayForm;
begin
  Self.MainConfig.TimerReset;
  frm := THolidayForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(THolidayForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
  end;
end;

procedure TMenuForm.btnLogoutClick(Sender: TObject);
begin
  Self.MainConfig.User := TUserModel.Create;
  Self.MainConfig.CurrentForm := 'LoginForm';
  Self.Close;
end;

procedure TMenuForm.btnMenuClick(Sender: TObject);
begin
  pnlMenu.Visible := not pnlMenu.Visible;
end;

procedure TMenuForm.btnMyDataClick(Sender: TObject);
var
  frm: TPersonalDataForm;
begin
  Self.MainConfig.TimerReset;
  frm := TPersonalDataForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TPersonalDataForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
  end;
end;

procedure TMenuForm.btnTimeDataClick(Sender: TObject);
var
  frm: TTimeDataForm;
begin
  Self.MainConfig.TimerReset;
  frm := TTimeDataForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := false;
  await(TTimeDataForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  try
    Self.Hide;
    await(TModalResult, frm.Execute);
  finally
    frm.Free;
    Self.Show;
    Self.WebFormResize(Sender);
  end;
end;

procedure TMenuForm.ClockInCallback(Sender: TObject);
begin
  Self.GetStatus;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  if Self.MainConfig.OverviewConfig.LastStamps then
    Self.GetLastStamps;
  if Self.MainConfig.OverviewConfig.ForwardAccounts then
    Self.GetForwardAccounts;
  if Self.MainConfig.OverviewConfig.Notice then
    Self.GetNotice;
  if Self.MainConfig.OverviewConfig.MonthOverview then
    Self.GetOverview;
end;

procedure TMenuForm.GetCurrentBalance(index: Integer);
var
  model: TValueModel;
  procedure Callback(Sender: TObject);
  var
    helper: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      helper := Sender as TValueModel;
      sgForwardAccounts.Cells[2, index + 1] := AlignRight(helper.Value);
      sgForwardAccounts.Cells[4, index + 1] := helper.Einheit;
    end;
    Self.GetCurrentBalance(index + 1);
  end;

begin
  if index < Self.ForwardAccounts.Count then
  begin
    model := TValueModel.Create;
    model.OnPropertyChanged := Callback;
    model.GetCurrentBalance(Self.MainConfig.Uri,
      Self.MainConfig.User.PersonalNr, StrToInt(Self.ForwardAccounts[index]),
      Self.MainConfig.CommonConfig.DecimalValues);
  end;
end;

procedure TMenuForm.GetForwardAccounts;
begin
  if Self.ForwardAccounts = nil then
    Self.ForwardAccounts := TStringList.Create;
  Self.ForwardAccounts.CommaText :=
    Self.MainConfig.OverviewConfig.SelectedForwardAccounts;
  sgForwardAccounts.ColCount := 5;
  sgForwardAccounts.RowCount := Max(2, Self.ForwardAccounts.Count + 1);
  sgForwardAccounts.FixedCols := 0;
  sgForwardAccounts.FixedRows := 1;
  sgForwardAccounts.ColWidths[0] := 5;
  sgForwardAccounts.ColWidths[1] := 100;
  sgForwardAccounts.ColWidths[2] := 50;
  sgForwardAccounts.ColWidths[3] := 5;
  sgForwardAccounts.ColWidths[4] := 50;
  sgForwardAccounts.Cells[0, 0] := '';
  sgForwardAccounts.Cells[1, 0] := Bold('Zeitart');
  sgForwardAccounts.Cells[2, 0] := AlignRight(Bold('Saldo'));
  sgForwardAccounts.Cells[3, 0] := '';
  sgForwardAccounts.Cells[4, 0] := Bold('Einheit');
  Self.GetZeitart(0);
end;

procedure TMenuForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TMenuForm.GetLastStamps;
var
  lst: TStampList;
begin
  lst := TStampList.Create;
  lst.OnPropertyChanged := GetLastStampsCallback;
  lst.GetLastStamps(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.OverviewConfig.StampsCount, saAll);
end;

procedure TMenuForm.GetLastStampsCallback(Sender: TObject);
var
  i, r: Integer;
  lst: TStampList;
begin
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    sgLastStamps.ColCount := 7
  else
    sgLastStamps.ColCount := 5;
  sgLastStamps.RowCount := 2;
  sgLastStamps.FixedCols := 0;
  sgLastStamps.FixedRows := 1;
  sgLastStamps.ColWidths[0] := 5;
  sgLastStamps.ColWidths[1] := 25;
  sgLastStamps.ColWidths[2] := 60;
  sgLastStamps.ColWidths[3] := 40;
  sgLastStamps.ColWidths[4] := 20;
  sgLastStamps.Cells[2, 0] := Bold('Zeitpunkt');
  sgLastStamps.Cells[4, 0] := Bold('Art');
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
  begin
    sgLastStamps.ColWidths[5] := 200;
    sgLastStamps.ColWidths[6] := 150;
    sgLastStamps.Cells[5, 0] := Bold('Auftrag');
    sgLastStamps.Cells[6, 0] := Bold('Tätigkeit');
  end;
  lst := Sender as TStampList;
  if lst <> nil then
  begin
    for i := 0 to lst.Count - 1 do
    begin
      r := sgLastStamps.RowCount;
      Inc(r);
      sgLastStamps.RowCount := r;
      sgLastStamps.Cells[1, r - 2] := FormatDateTime('ddd.',
        lst.Items[i].Zeitpunkt);
      sgLastStamps.Cells[2, r - 2] := FormatDateTime('dd.mm.yyyy',
        lst.Items[i].Zeitpunkt);
      sgLastStamps.Cells[3, r - 2] := FormatDateTime('hh:nn',
        lst.Items[i].Zeitpunkt);
      sgLastStamps.Cells[4, r - 2] := lst.Items[i].Art;
      if Self.MainConfig.CommonConfig.WorkOrderTimes then
      begin
        sgLastStamps.Cells[5, r - 2] := lst.Items[i].Fak.ToString;
        sgLastStamps.Cells[6, r - 2] := lst.Items[i].Taet.ToString;
      end;
    end;
    if sgLastStamps.RowCount > 2 then
    begin
      r := sgLastStamps.RowCount;
      Dec(r);
      sgLastStamps.RowCount := r;
    end;
  end;
end;

procedure TMenuForm.GetNotice;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TUserModel then
      edtInfo.Lines.Text := (Sender as TUserModel).Notice
    else
      edtInfo.Lines.Clear;
  end;

begin
  Self.MainConfig.User.OnPropertyChanged := Callback;
  Self.MainConfig.User.GetNotice(Self.MainConfig.Uri);
end;

procedure TMenuForm.GetOverview;
var
  i, j: Integer;
  startDate, aktDate: TDateTime;
  von, bis: string;
  Value: TValueModel;
  procedure Callback(Sender: TObject);
  var
    model: TValueModel;
  begin
    if Sender is TValueModel then
    begin
      model := Sender as TValueModel;
      sgMonthOverview.Cells[model.Col, model.Row] := AlignRight(model.Value);
      sgMonthOverview.Cells[model.Col + 1, model.Row] := '';
      sgMonthOverview.Cells[model.Col + 2, model.Row] := model.Einheit;
      sgMonthOverview.Cells[model.Col + 3, model.Row] := AlignRight(model.Tage);
    end;
  end;

begin
  sgMonthOverview.ColCount :=
    2 + (4 * Self.MainConfig.OverviewConfig.ColumnList.Count);
  sgMonthOverview.RowCount := Self.MainConfig.OverviewConfig.MonthCount + 1;
  sgMonthOverview.ColWidths[0] := 5;
  sgMonthOverview.ColWidths[1] := 75;
  sgMonthOverview.Cells[1, 0] := Bold('Monat');
  for i := 0 to Self.MainConfig.OverviewConfig.ColumnList.Count - 1 do
  begin
    sgMonthOverview.ColWidths[(i * 4) + 2] := 75;
    sgMonthOverview.ColWidths[(i * 4) + 3] := 5;
    sgMonthOverview.ColWidths[(i * 4) + 4] := 25;
    if Self.MainConfig.OverviewConfig.ColumnList.Items[i].InTagen then
      sgMonthOverview.ColWidths[(i * 4) + 5] := 50
    else
      sgMonthOverview.ColWidths[(i * 4) + 5] := 0;
    sgMonthOverview.Cells[(i * 4) + 2, 0] :=
      AlignRight(Bold(Self.MainConfig.OverviewConfig.ColumnList.Items[i]
      .Bezeichnung));
    sgMonthOverview.Cells[(i * 4) + 5, 0] := AlignRight(Bold('an Tagen'));
  end;
  startDate := Date;
  aktDate := startDate;
  for i := 1 to Self.MainConfig.OverviewConfig.MonthCount do
  begin
    sgMonthOverview.Cells[1, i] := FormatDateTime('mmm yyyy', aktDate);
    aktDate := PriorMonth(aktDate);
  end;
  for i := 0 to Self.MainConfig.OverviewConfig.ColumnList.Count - 1 do
  begin
    aktDate := startDate;
    for j := 1 to Self.MainConfig.OverviewConfig.MonthCount do
    begin
      von := FormatDateTime('yyyymmdd', StartOfTheMonth(aktDate));
      if aktDate < StartOfTheMonth(startDate) then
        bis := FormatDateTime('yyyymmdd', EndOfTheMonth(aktDate))
      else
        bis := FormatDateTime('yyyymmdd', startDate - 1);
      Value := TValueModel.Create;
      Value.Row := j;
      Value.Col := (i * 4) + 2;
      Value.OnPropertyChanged := Callback;
      Value.GetZaSum(Self.MainConfig.Uri, Self.MainConfig.User.PersonalNr,
        Self.MainConfig.OverviewConfig.ColumnList.Items[i].ZeitartIds, von, bis,
        Self.MainConfig.CommonConfig.DecimalValues);
      aktDate := PriorMonth(aktDate);
    end;
  end;
end;

procedure TMenuForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TMenuForm.GetZeitart(index: Integer);
var
  model: TZeitartModel;
  procedure Callback1(Sender: TObject);
  var
    helper: TZeitartModel;
  begin
    if Sender is TZeitartModel then
    begin
      helper := Sender as TZeitartModel;
      sgForwardAccounts.Cells[1, index + 1] := helper.Bezeichnung;
    end;
    Self.GetZeitart(index + 1);
  end;

begin
  if index < Self.ForwardAccounts.Count then
  begin
    model := TZeitartModel.Create;
    model.Id := StrToInt(Self.ForwardAccounts[index]);
    model.OnPropertyChanged := Callback1;
    model.GetById(Self.MainConfig.Uri);
  end
  else
    Self.GetCurrentBalance(0);
end;

procedure TMenuForm.SetButtons;
var
  i, j: Integer;
  btn: TBitBtn;
begin
  Self.btnMyData.Visible := Self.MainConfig.MenuConfig.btnMyData;
  Self.btnClockIn.Visible := Self.MainConfig.MenuConfig.btnClockIn;
  Self.btnTimeData.Visible := Self.MainConfig.MenuConfig.btnTimeData;
  Self.btnAbwPlanner.Visible := Self.MainConfig.MenuConfig.btnAbwPlanner;
  Self.btnHoliday.Visible := Self.MainConfig.MenuConfig.btnHoliday;
  Self.btnLogout.Visible := Self.MainConfig.MenuConfig.btnLogout;
  j := 0;
  for i := 0 to Self.ComponentCount - 1 do
    if Self.Components[i] is TBitBtn then
    begin
      btn := Self.Components[i] as TBitBtn;
      if btn.Visible and (btn.Tag = 1) then
      begin
        btn.Top := (j * 56) + 8;
        Inc(j);
      end;
    end;
end;

procedure TMenuForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TMenuForm.SetForwardAccounts(const Value: TStringList);
begin
  FForwardAccounts := Value;
end;

procedure TMenuForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.SetOverviewConfig;
  Self.SetButtons;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.GetStatus;
  if Self.MainConfig.OverviewConfig.LastStamps then
    Self.GetLastStamps;
  if Self.MainConfig.OverviewConfig.ForwardAccounts then
    Self.GetForwardAccounts;
  if Self.MainConfig.OverviewConfig.Notice then
    Self.GetNotice;
  if Self.MainConfig.OverviewConfig.MonthOverview then
    Self.GetOverview;
  WebFormResize(Self);
end;

procedure TMenuForm.SetOverviewConfig;
begin
  pnlTopPart1.Visible := Self.MainConfig.OverviewConfig.LastStamps;
  ws2.Visible := Self.MainConfig.OverviewConfig.LastStamps;
  pnlTopPart2.Visible := Self.MainConfig.OverviewConfig.ForwardAccounts;
  pnlTopPart3.Visible := Self.MainConfig.OverviewConfig.Notice;
  ws3.Visible := Self.MainConfig.OverviewConfig.Notice;
  pnlBottom.Visible := Self.MainConfig.OverviewConfig.MonthOverview;
  ws1.Visible := Self.MainConfig.OverviewConfig.MonthOverview;
  if not Self.MainConfig.OverviewConfig.MonthOverview then
    pnlTop.Align := alClient;
end;

procedure TMenuForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TMenuForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp := nil;
  Self.FakStamp := nil;
end;

procedure TMenuForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TMenuForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnMenu.Width := 24;
    btnMenu.Height := 24;
    btnMenu.Top := 4;
    btnMenu.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    btnMenu.Visible := true;
    pnlMenu.Visible := false;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnMenu.Width := 48;
    btnMenu.Height := 48;
    btnMenu.Top := 8;
    btnMenu.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    btnMenu.Visible := false;
    pnlMenu.Visible := true;
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnMenu.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlTop.Height := (pnlOverview.ClientHeight - ws1.Height) div 2;
  if pnlTopPart1.Visible and pnlTopPart2.Visible and pnlTopPart3.Visible then
  begin
    pnlTopPart1.Width := (pnlTop.ClientWidth - ws2.Width - ws3.Width) div 3;
    pnlTopPart3.Width := (pnlTop.ClientWidth - ws2.Width - ws3.Width) div 3;
  end;
  if pnlTopPart1.Visible and pnlTopPart2.Visible and not pnlTopPart3.Visible
  then
  begin
    pnlTopPart1.Width := (pnlTop.ClientWidth - ws2.Width) div 2;
  end;
  if not pnlTopPart1.Visible and pnlTopPart2.Visible and pnlTopPart3.Visible
  then
  begin
    pnlTopPart3.Width := (pnlTop.ClientWidth - ws3.Width) div 2;
  end;
  if pnlTopPart1.Visible and not pnlTopPart2.Visible and pnlTopPart3.Visible
  then
  begin
    ws3.Visible := false;
    pnlTopPart3.Align := alClient;
    pnlTopPart1.Width := (pnlTop.ClientWidth - ws2.Width) div 2;
  end;
  if pnlTopPart1.Visible and not pnlTopPart2.Visible and not pnlTopPart3.Visible
  then
  begin
    ws2.Visible := false;
    pnlTopPart1.Align := alClient;
  end;
  if not pnlTopPart1.Visible and pnlTopPart2.Visible and not pnlTopPart3.Visible
  then
  begin
  end;
  if not pnlTopPart1.Visible and not pnlTopPart2.Visible and pnlTopPart3.Visible
  then
  begin
    ws3.Visible := false;
    pnlTopPart3.Align := alClient;
  end;
end;

procedure TMenuForm.WebFormShow(Sender: TObject);
begin
  WebFormResize(Sender);
end;

procedure TMenuForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnMenu := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlMenu := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  btnMyData := TBitBtn.Create(Self);
  btnClockIn := TBitBtn.Create(Self);
  btnTimeData := TBitBtn.Create(Self);
  btnAbwPlanner := TBitBtn.Create(Self);
  btnHoliday := TBitBtn.Create(Self);
  btnLogout := TBitBtn.Create(Self);
  pnlOverview := TPanel.Create(Self);
  pnlTop := TPanel.Create(Self);
  pnlTopPart1 := TPanel.Create(Self);
  pnlTopPart1Header := TPanel.Create(Self);
  pnlTopPart1Main := TPanel.Create(Self);
  sgLastStamps := TStringGrid.Create(Self);
  ws2 := TSplitter.Create(Self);
  pnlTopPart2 := TPanel.Create(Self);
  pnlTopPart2Header := TPanel.Create(Self);
  pnlTopPart2Main := TPanel.Create(Self);
  sgForwardAccounts := TStringGrid.Create(Self);
  ws3 := TSplitter.Create(Self);
  pnlTopPart3 := TPanel.Create(Self);
  pnlTopPart3Header := TPanel.Create(Self);
  pnlTopPart3Main := TPanel.Create(Self);
  edtInfo := TRichEdit.Create(Self);
  pnlBottom := TPanel.Create(Self);
  pnlBottomHeader := TPanel.Create(Self);
  pnlBottomMain := TPanel.Create(Self);
  sgMonthOverview := TStringGrid.Create(Self);
  ws1 := TSplitter.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnMenu.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlMenu.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  btnMyData.BeforeLoadDFMValues;
  btnClockIn.BeforeLoadDFMValues;
  btnTimeData.BeforeLoadDFMValues;
  btnAbwPlanner.BeforeLoadDFMValues;
  btnHoliday.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  pnlOverview.BeforeLoadDFMValues;
  pnlTop.BeforeLoadDFMValues;
  pnlTopPart1.BeforeLoadDFMValues;
  pnlTopPart1Header.BeforeLoadDFMValues;
  pnlTopPart1Main.BeforeLoadDFMValues;
  sgLastStamps.BeforeLoadDFMValues;
  ws2.BeforeLoadDFMValues;
  pnlTopPart2.BeforeLoadDFMValues;
  pnlTopPart2Header.BeforeLoadDFMValues;
  pnlTopPart2Main.BeforeLoadDFMValues;
  sgForwardAccounts.BeforeLoadDFMValues;
  ws3.BeforeLoadDFMValues;
  pnlTopPart3.BeforeLoadDFMValues;
  pnlTopPart3Header.BeforeLoadDFMValues;
  pnlTopPart3Main.BeforeLoadDFMValues;
  edtInfo.BeforeLoadDFMValues;
  pnlBottom.BeforeLoadDFMValues;
  pnlBottomHeader.BeforeLoadDFMValues;
  pnlBottomMain.BeforeLoadDFMValues;
  sgMonthOverview.BeforeLoadDFMValues;
  ws1.BeforeLoadDFMValues;
  try
    Name := 'MenuForm';
    Width := 640;
    Height := 528;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UMenuForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnMenu.SetParentComponent(pnlHeader);
    btnMenu.Name := 'btnMenu';
    btnMenu.Left := 16;
    btnMenu.Top := 16;
    btnMenu.Width := 32;
    btnMenu.Height := 32;
    btnMenu.HeightPercent := 100.000000000000000000;
    btnMenu.WidthPercent := 100.000000000000000000;
    btnMenu.ChildOrder := 2;
    SetEvent(btnMenu, Self, 'OnClick', 'btnMenuClick');
    btnMenu.Picture.LoadFromFile('UMenuForm.pnlHeader.btnMenu.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 504;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlMenu.SetParentComponent(Self);
    pnlMenu.Name := 'pnlMenu';
    pnlMenu.Left := 0;
    pnlMenu.Top := 92;
    pnlMenu.Width := 178;
    pnlMenu.Height := 412;
    pnlMenu.Align := alLeft;
    pnlMenu.Caption := 'pnlMenu';
    pnlMenu.ChildOrder := 3;
    pnlMenu.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlMenu);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 8;
    WebLabel1.Width := 40;
    WebLabel1.Height := 21;
    WebLabel1.Caption := 'Men'#252;
    WebLabel1.Font.Charset := ANSI_CHARSET;
    WebLabel1.Font.Color := clNavy;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Segoe UI Semibold';
    WebLabel1.Font.Style := [fsBold,fsItalic];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    btnMyData.SetParentComponent(pnlMenu);
    btnMyData.Name := 'btnMyData';
    btnMyData.Tag := 1;
    btnMyData.Left := 8;
    btnMyData.Top := 32;
    btnMyData.Width := 160;
    btnMyData.Height := 48;
    btnMyData.Caption := 'Pers'#246'nliche Daten';
    btnMyData.Color := clNone;
    btnMyData.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnMyData.Glyph.png');
    btnMyData.GlyphSize := 32;
    btnMyData.HeightPercent := 100.000000000000000000;
    btnMyData.WidthPercent := 100.000000000000000000;
    SetEvent(btnMyData, Self, 'OnClick', 'btnMyDataClick');
    btnClockIn.SetParentComponent(pnlMenu);
    btnClockIn.Name := 'btnClockIn';
    btnClockIn.Tag := 1;
    btnClockIn.Left := 8;
    btnClockIn.Top := 88;
    btnClockIn.Width := 160;
    btnClockIn.Height := 48;
    btnClockIn.Caption := 'Stempelbereich';
    btnClockIn.Color := clNone;
    btnClockIn.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnClockIn.Glyph.png');
    btnClockIn.GlyphSize := 32;
    btnClockIn.HeightPercent := 100.000000000000000000;
    btnClockIn.WidthPercent := 100.000000000000000000;
    SetEvent(btnClockIn, Self, 'OnClick', 'btnClockInClick');
    btnTimeData.SetParentComponent(pnlMenu);
    btnTimeData.Name := 'btnTimeData';
    btnTimeData.Tag := 1;
    btnTimeData.Left := 8;
    btnTimeData.Top := 144;
    btnTimeData.Width := 160;
    btnTimeData.Height := 48;
    btnTimeData.Caption := 'Zeitdaten';
    btnTimeData.Color := clNone;
    btnTimeData.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnTimeData.Glyph.png');
    btnTimeData.GlyphSize := 32;
    btnTimeData.HeightPercent := 100.000000000000000000;
    btnTimeData.WidthPercent := 100.000000000000000000;
    SetEvent(btnTimeData, Self, 'OnClick', 'btnTimeDataClick');
    btnAbwPlanner.SetParentComponent(pnlMenu);
    btnAbwPlanner.Name := 'btnAbwPlanner';
    btnAbwPlanner.Tag := 1;
    btnAbwPlanner.Left := 8;
    btnAbwPlanner.Top := 200;
    btnAbwPlanner.Width := 160;
    btnAbwPlanner.Height := 48;
    btnAbwPlanner.Hint := 'Abwesenheitkalender';
    btnAbwPlanner.Caption := 'Abw-Kalender';
    btnAbwPlanner.Color := clNone;
    btnAbwPlanner.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnAbwPlanner.Glyph.png');
    btnAbwPlanner.GlyphSize := 32;
    btnAbwPlanner.HeightPercent := 100.000000000000000000;
    btnAbwPlanner.ShowHint := True;
    btnAbwPlanner.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbwPlanner, Self, 'OnClick', 'btnAbwPlannerClick');
    btnHoliday.SetParentComponent(pnlMenu);
    btnHoliday.Name := 'btnHoliday';
    btnHoliday.Tag := 1;
    btnHoliday.Left := 8;
    btnHoliday.Top := 256;
    btnHoliday.Width := 160;
    btnHoliday.Height := 48;
    btnHoliday.Caption := 'Urlaubsantrag';
    btnHoliday.Color := clNone;
    btnHoliday.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnHoliday.Glyph.png');
    btnHoliday.GlyphSize := 32;
    btnHoliday.HeightPercent := 100.000000000000000000;
    btnHoliday.WidthPercent := 100.000000000000000000;
    SetEvent(btnHoliday, Self, 'OnClick', 'btnHolidayClick');
    btnLogout.SetParentComponent(pnlMenu);
    btnLogout.Name := 'btnLogout';
    btnLogout.Tag := 1;
    btnLogout.Left := 8;
    btnLogout.Top := 312;
    btnLogout.Width := 160;
    btnLogout.Height := 48;
    btnLogout.Caption := 'Abmelden';
    btnLogout.Color := clNone;
    btnLogout.Glyph.LoadFromFile('UMenuForm.pnlMenu.btnLogout.Glyph.png');
    btnLogout.GlyphSize := 32;
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    pnlOverview.SetParentComponent(Self);
    pnlOverview.Name := 'pnlOverview';
    pnlOverview.Left := 178;
    pnlOverview.Top := 92;
    pnlOverview.Width := 462;
    pnlOverview.Height := 412;
    pnlOverview.Align := alClient;
    pnlOverview.Caption := 'pnlOverview';
    pnlOverview.ChildOrder := 4;
    pnlOverview.ShowCaption := False;
    pnlTop.SetParentComponent(pnlOverview);
    pnlTop.Name := 'pnlTop';
    pnlTop.Left := 0;
    pnlTop.Top := 0;
    pnlTop.Width := 462;
    pnlTop.Height := 192;
    pnlTop.Align := alTop;
    pnlTop.Caption := 'pnlTop';
    pnlTop.ShowCaption := False;
    pnlTopPart1.SetParentComponent(pnlTop);
    pnlTopPart1.Name := 'pnlTopPart1';
    pnlTopPart1.Left := 0;
    pnlTopPart1.Top := 0;
    pnlTopPart1.Width := 150;
    pnlTopPart1.Height := 192;
    pnlTopPart1.Align := alLeft;
    pnlTopPart1.Caption := 'pnlTopPart1';
    pnlTopPart1.ShowCaption := False;
    pnlTopPart1Header.SetParentComponent(pnlTopPart1);
    pnlTopPart1Header.Name := 'pnlTopPart1Header';
    pnlTopPart1Header.Left := 0;
    pnlTopPart1Header.Top := 0;
    pnlTopPart1Header.Width := 150;
    pnlTopPart1Header.Height := 29;
    pnlTopPart1Header.Align := alTop;
    pnlTopPart1Header.Alignment := taLeftJustify;
    pnlTopPart1Header.Caption := 'Letzte Stempelungen';
    pnlTopPart1Header.Font.Charset := ANSI_CHARSET;
    pnlTopPart1Header.Font.Color := clNavy;
    pnlTopPart1Header.Font.Height := -16;
    pnlTopPart1Header.Font.Name := 'Segoe UI Semibold';
    pnlTopPart1Header.Font.Style := [fsBold,fsItalic];
    pnlTopPart1Header.ParentFont := False;
    pnlTopPart1Main.SetParentComponent(pnlTopPart1);
    pnlTopPart1Main.Name := 'pnlTopPart1Main';
    pnlTopPart1Main.Left := 0;
    pnlTopPart1Main.Top := 29;
    pnlTopPart1Main.Width := 150;
    pnlTopPart1Main.Height := 163;
    pnlTopPart1Main.Align := alClient;
    pnlTopPart1Main.Caption := 'pnlTopPart1Main';
    pnlTopPart1Main.ChildOrder := 1;
    pnlTopPart1Main.ShowCaption := False;
    sgLastStamps.SetParentComponent(pnlTopPart1Main);
    sgLastStamps.Name := 'sgLastStamps';
    sgLastStamps.Left := 0;
    sgLastStamps.Top := 0;
    sgLastStamps.Width := 150;
    sgLastStamps.Height := 163;
    sgLastStamps.Align := alClient;
    sgLastStamps.ColCount := 4;
    sgLastStamps.FixedCols := 0;
    sgLastStamps.RowCount := 2;
    sgLastStamps.Options := [goFixedHorzLine,goHorzLine,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgLastStamps.TabOrder := 0;
    sgLastStamps.RangeEdit.Max := 100.000000000000000000;
    sgLastStamps.RangeEdit.Step := 1.000000000000000000;
    sgLastStamps.HeightPercent := 100.000000000000000000;
    sgLastStamps.WidthPercent := 100.000000000000000000;
    ws2.SetParentComponent(pnlTop);
    ws2.Name := 'ws2';
    ws2.Left := 150;
    ws2.Top := 0;
    ws2.Width := 5;
    ws2.Height := 192;
    ws2.Align := alLeft;
    ws2.ChildOrder := 1;
    ws2.Color := clBtnFace;
    pnlTopPart2.SetParentComponent(pnlTop);
    pnlTopPart2.Name := 'pnlTopPart2';
    pnlTopPart2.Left := 155;
    pnlTopPart2.Top := 0;
    pnlTopPart2.Width := 150;
    pnlTopPart2.Height := 192;
    pnlTopPart2.Align := alClient;
    pnlTopPart2.Caption := 'pnlTopPart2';
    pnlTopPart2.ChildOrder := 2;
    pnlTopPart2Header.SetParentComponent(pnlTopPart2);
    pnlTopPart2Header.Name := 'pnlTopPart2Header';
    pnlTopPart2Header.Left := 0;
    pnlTopPart2Header.Top := 0;
    pnlTopPart2Header.Width := 150;
    pnlTopPart2Header.Height := 29;
    pnlTopPart2Header.Align := alTop;
    pnlTopPart2Header.Alignment := taLeftJustify;
    pnlTopPart2Header.Caption := 'Vortragskonten';
    pnlTopPart2Header.Font.Charset := ANSI_CHARSET;
    pnlTopPart2Header.Font.Color := clNavy;
    pnlTopPart2Header.Font.Height := -16;
    pnlTopPart2Header.Font.Name := 'Segoe UI Semibold';
    pnlTopPart2Header.Font.Style := [fsBold,fsItalic];
    pnlTopPart2Header.ParentFont := False;
    pnlTopPart2Main.SetParentComponent(pnlTopPart2);
    pnlTopPart2Main.Name := 'pnlTopPart2Main';
    pnlTopPart2Main.Left := 0;
    pnlTopPart2Main.Top := 29;
    pnlTopPart2Main.Width := 150;
    pnlTopPart2Main.Height := 163;
    pnlTopPart2Main.Align := alClient;
    pnlTopPart2Main.Caption := 'pnlTopPart1Main';
    pnlTopPart2Main.ChildOrder := 1;
    pnlTopPart2Main.ShowCaption := False;
    sgForwardAccounts.SetParentComponent(pnlTopPart2Main);
    sgForwardAccounts.Name := 'sgForwardAccounts';
    sgForwardAccounts.Left := 0;
    sgForwardAccounts.Top := 0;
    sgForwardAccounts.Width := 150;
    sgForwardAccounts.Height := 163;
    sgForwardAccounts.Align := alClient;
    sgForwardAccounts.ColCount := 4;
    sgForwardAccounts.FixedCols := 0;
    sgForwardAccounts.RowCount := 2;
    sgForwardAccounts.Options := [goFixedHorzLine,goHorzLine,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgForwardAccounts.TabOrder := 0;
    sgForwardAccounts.RangeEdit.Max := 100.000000000000000000;
    sgForwardAccounts.RangeEdit.Step := 1.000000000000000000;
    sgForwardAccounts.HeightPercent := 100.000000000000000000;
    sgForwardAccounts.WidthPercent := 100.000000000000000000;
    ws3.SetParentComponent(pnlTop);
    ws3.Name := 'ws3';
    ws3.Left := 305;
    ws3.Top := 0;
    ws3.Width := 5;
    ws3.Height := 192;
    ws3.Align := alRight;
    ws3.ChildOrder := 3;
    ws3.Color := clBtnFace;
    pnlTopPart3.SetParentComponent(pnlTop);
    pnlTopPart3.Name := 'pnlTopPart3';
    pnlTopPart3.Left := 310;
    pnlTopPart3.Top := 0;
    pnlTopPart3.Width := 152;
    pnlTopPart3.Height := 192;
    pnlTopPart3.Align := alRight;
    pnlTopPart3.Caption := 'pnlTopPart3';
    pnlTopPart3.ChildOrder := 4;
    pnlTopPart3Header.SetParentComponent(pnlTopPart3);
    pnlTopPart3Header.Name := 'pnlTopPart3Header';
    pnlTopPart3Header.Left := 0;
    pnlTopPart3Header.Top := 0;
    pnlTopPart3Header.Width := 152;
    pnlTopPart3Header.Height := 29;
    pnlTopPart3Header.Align := alTop;
    pnlTopPart3Header.Alignment := taLeftJustify;
    pnlTopPart3Header.Caption := 'Pers'#246'nliche Info';
    pnlTopPart3Header.Font.Charset := ANSI_CHARSET;
    pnlTopPart3Header.Font.Color := clNavy;
    pnlTopPart3Header.Font.Height := -16;
    pnlTopPart3Header.Font.Name := 'Segoe UI Semibold';
    pnlTopPart3Header.Font.Style := [fsBold,fsItalic];
    pnlTopPart3Header.ParentFont := False;
    pnlTopPart3Main.SetParentComponent(pnlTopPart3);
    pnlTopPart3Main.Name := 'pnlTopPart3Main';
    pnlTopPart3Main.Left := 0;
    pnlTopPart3Main.Top := 29;
    pnlTopPart3Main.Width := 152;
    pnlTopPart3Main.Height := 163;
    pnlTopPart3Main.Align := alClient;
    pnlTopPart3Main.Caption := 'pnlTopPart1Main';
    pnlTopPart3Main.ChildOrder := 1;
    pnlTopPart3Main.ShowCaption := False;
    edtInfo.SetParentComponent(pnlTopPart3Main);
    edtInfo.Name := 'edtInfo';
    edtInfo.Left := 0;
    edtInfo.Top := 0;
    edtInfo.Width := 152;
    edtInfo.Height := 163;
    edtInfo.Align := alClient;
    edtInfo.BorderStyle := bsSingle;
    edtInfo.Color := clWhite;
    edtInfo.ReadOnly := True;
    pnlBottom.SetParentComponent(pnlOverview);
    pnlBottom.Name := 'pnlBottom';
    pnlBottom.Left := 0;
    pnlBottom.Top := 197;
    pnlBottom.Width := 462;
    pnlBottom.Height := 215;
    pnlBottom.Align := alClient;
    pnlBottom.Caption := 'pnlBottom';
    pnlBottom.ChildOrder := 1;
    pnlBottomHeader.SetParentComponent(pnlBottom);
    pnlBottomHeader.Name := 'pnlBottomHeader';
    pnlBottomHeader.Left := 0;
    pnlBottomHeader.Top := 0;
    pnlBottomHeader.Width := 462;
    pnlBottomHeader.Height := 29;
    pnlBottomHeader.Align := alTop;
    pnlBottomHeader.Alignment := taLeftJustify;
    pnlBottomHeader.Caption := 'Salden'#252'bersicht';
    pnlBottomHeader.ChildOrder := 1;
    pnlBottomHeader.Font.Charset := ANSI_CHARSET;
    pnlBottomHeader.Font.Color := clNavy;
    pnlBottomHeader.Font.Height := -16;
    pnlBottomHeader.Font.Name := 'Segoe UI Semibold';
    pnlBottomHeader.Font.Style := [fsBold,fsItalic];
    pnlBottomHeader.ParentFont := False;
    pnlBottomMain.SetParentComponent(pnlBottom);
    pnlBottomMain.Name := 'pnlBottomMain';
    pnlBottomMain.Left := 0;
    pnlBottomMain.Top := 29;
    pnlBottomMain.Width := 462;
    pnlBottomMain.Height := 186;
    pnlBottomMain.Align := alClient;
    pnlBottomMain.Caption := 'pnlBottomMain';
    pnlBottomMain.ChildOrder := 1;
    pnlBottomMain.ShowCaption := False;
    sgMonthOverview.SetParentComponent(pnlBottomMain);
    sgMonthOverview.Name := 'sgMonthOverview';
    sgMonthOverview.Left := 0;
    sgMonthOverview.Top := 0;
    sgMonthOverview.Width := 462;
    sgMonthOverview.Height := 186;
    sgMonthOverview.Align := alClient;
    sgMonthOverview.ColCount := 1;
    sgMonthOverview.DefaultColWidth := 500;
    sgMonthOverview.FixedCols := 0;
    sgMonthOverview.RowCount := 2;
    sgMonthOverview.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgMonthOverview.TabOrder := 0;
    sgMonthOverview.RangeEdit.Max := 100.000000000000000000;
    sgMonthOverview.RangeEdit.Step := 1.000000000000000000;
    sgMonthOverview.HeightPercent := 100.000000000000000000;
    sgMonthOverview.WidthPercent := 100.000000000000000000;
    ws1.SetParentComponent(pnlOverview);
    ws1.Name := 'ws1';
    ws1.Left := 0;
    ws1.Top := 192;
    ws1.Width := 462;
    ws1.Height := 5;
    ws1.Align := alTop;
    ws1.ChildOrder := 2;
    ws1.Color := clBtnFace;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnMenu.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlMenu.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    btnMyData.AfterLoadDFMValues;
    btnClockIn.AfterLoadDFMValues;
    btnTimeData.AfterLoadDFMValues;
    btnAbwPlanner.AfterLoadDFMValues;
    btnHoliday.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    pnlOverview.AfterLoadDFMValues;
    pnlTop.AfterLoadDFMValues;
    pnlTopPart1.AfterLoadDFMValues;
    pnlTopPart1Header.AfterLoadDFMValues;
    pnlTopPart1Main.AfterLoadDFMValues;
    sgLastStamps.AfterLoadDFMValues;
    ws2.AfterLoadDFMValues;
    pnlTopPart2.AfterLoadDFMValues;
    pnlTopPart2Header.AfterLoadDFMValues;
    pnlTopPart2Main.AfterLoadDFMValues;
    sgForwardAccounts.AfterLoadDFMValues;
    ws3.AfterLoadDFMValues;
    pnlTopPart3.AfterLoadDFMValues;
    pnlTopPart3Header.AfterLoadDFMValues;
    pnlTopPart3Main.AfterLoadDFMValues;
    edtInfo.AfterLoadDFMValues;
    pnlBottom.AfterLoadDFMValues;
    pnlBottomHeader.AfterLoadDFMValues;
    pnlBottomMain.AfterLoadDFMValues;
    sgMonthOverview.AfterLoadDFMValues;
    ws1.AfterLoadDFMValues;
  end;
end;

end.
